<template>
  <div class="container" v-if="show">
    <div class="contact-header" id="contact-header">
      <img :src="info.lineId ? getProfile(info.lineId) : info.photo" onerror="this.src='\/0399c6612ff700e43d750ed790e242e8.png'" class="contact-profile-image" alt="profile image" height="60" width="60">
      <div class="contact-profile">
        <span class="chat-paragraph-14-gray">{{id}}</span>
        <span class="chat-header-24-black">{{info.name}}
          <button
            class="customer-button"
            :class="info.patientId !== 0 ? 'active' : 'disabled'"
            v-on:click="() => { info.patientId !== 0 && goToCustomerPage() }"
          >
            <img class="icon" src="https://storage.healthathome.in.th/bc8243e7-b78d-409a-8c21-655af7d73b54.svg" width="35px" height="35px">
          </button>
        </span>
        <span
          v-if="!noteDetail.status.length && !noteDetail.note.length && showNoteSection"
          class="note-button"
          v-on:click="() => { showNoteDialog = true }"
        >
          เพิ่มแท็ก/โน้ต<i style="margin-left: 4px;" class="el-icon-edit"></i>
        </span>
        <div
          v-if="(noteDetail.status.length || noteDetail.note.length) && showNoteSection"
          style="display: flex; flex-direction: column; gap: 10px;"
        >
          <div
            v-if="noteDetail.status.length"
            class="tag-container"
          >
            <div
              v-for="s in rawStatus.filter(status => noteDetail.status.includes(status.value))"
              :key="s.title"
              class="tag"
              :style="`
                cursor: auto;
                --t-color: ${s.textColor};
                --bg-color: ${s.bgColor};
                --bg-color-hover: ${s.bgColor};
              `"
            >
              <img
                :src="s.icon"
                :alt="s.title"
              >
              <span>{{ s.title }}</span>
            </div>
          </div>
          <span :style="`margin-top: ${!noteDetail.status.length ? 8 : 0}px; display: flex; align-items: baseline;`">
            <div
              class="note"
              style="
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                max-width: calc(100vw - 576px);
              "
            >
              {{ noteDetail.note }}
            </div>
            <span
              class="note-button"
              style="margin-top: 0; margin-left: 4px;"
              v-on:click="() => { showNoteDialog = true }"
            >
              แก้ไข <i style="margin-left: 4px;" class="el-icon-edit"></i>
            </span>
          </span>
        </div>
      </div>
    </div>
    <div
      class="chat-container"
      id="chat-container"
      ref="chat"
      @scroll="scrollHandler()"
    >
      <div v-if="loading" class="loading-container">
        <svg class="circular">
          <circle class="path" cx="20" cy="20" r="12" fill="none" stroke-width="3" stroke-miterlimit="6"></circle>
        </svg>
      </div>
      <div v-for="(item, index) in chat" :key="`${item.id}-${index}`">
        <div v-if="showDate(index)" class="date mt-20 mb-12">
          <span class="chat-paragraph-14-gray">{{getDate(chat[index].timestamp)}}</span>
        </div>
        <div v-if="index === 0" class="date mt-20 mb-12">
          <span class="chat-paragraph-14-gray">{{getDate(chat[index].timestamp)}}</span>
        </div>
        <div v-if="item.sender.type === 'line' && info.name === item.sender.name" class="people-customer mt-16">
          <img :src="getProfile(info.lineId)" onerror="this.src='\/0399c6612ff700e43d750ed790e242e8.png'" class="image" alt="profile image" height="28" width="28">
          <div v-if="item.type === 'text'" class="chatbox chat-paragraph-16-black" v-html="changeText(item.content)"></div>
          <a v-if="item.type === 'image' && item.content != ''" :href=item.content target="_blank">
            <img :src=item.content class="imagebox" alt="image">
          </a>
          <img v-if="item.type === 'sticker' && item.content != ''" :src=item.content class="stickerbox" alt="sticker">
          <a v-if="item.type === 'video' && item.content != ''" :href=item.content target="_blank">
            <img src="https://storage.healthathome.in.th/eb597c7f-ab59-4ad2-9bf3-27624ec8a3d0.svg" class="imagebox" alt="video">
          </a>
          <a v-if="item.type === 'audio' && item.content != ''" :href=item.content target="_blank">
            <img src="https://storage.healthathome.in.th/2e521bda-6642-4d66-adbd-21fbf8663afd.svg" class="imagebox" alt="audio">
          </a>
          <span class="time chat-paragraph-14-lightgray-2" style="margin-left: 12px;">{{getTime(item.timestamp)}}</span>
        </div>
        <div
          v-if="
            (item.sender.type === 'admin' && item.content != '' && item.sender.name !== 'Line') ||
            (item.sender.type === 'admin' && item.content != '' && item.sender.name === 'Line' && !['image', 'video', 'audio', 'sticker'].includes(item.type))
          "
          class="people-hah mt-16 sender-text"
        >
          {{showSenderName(item.sender.name)}}
        </div>
        <div v-if="item.sender.type === 'admin'" class="people-hah">
          <span
            v-if="
              (item.content != '' && item.sender.name !== 'Line') ||
              (item.content != '' && item.sender.name === 'Line' && !['image', 'video', 'audio', 'sticker'].includes(item.type))
            "
            class="time chat-paragraph-14-lightgray-2"
            style="margin-right: 20px;"
          >
            {{getTime(item.timestamp)}}
          </span>
          <div v-if="item.type === 'text' && item.sender.name !== 'Line'" class="chatbox chat-paragraph-16-white" v-html="changeText(item.content)"></div>
          <div v-if="item.type === 'text' && item.sender.name === 'Line'" class="chatbox-bot chat-paragraph-16-white" v-html="checkHaveHeader(changeText(item.content), 0)"></div>
          <a v-if="item.type === 'image' && item.content != '' && item.sender.name !== 'Line'" :href=item.content target="_blank">
            <img :src=item.content class="imagebox" alt="image">
          </a>
          <img v-if="item.type === 'sticker' && item.content != '' && item.sender.name !== 'Line'" :src=item.content class="stickerbox" alt="sticker">
          <a v-if="item.type === 'video' && item.content != '' && item.sender.name !== 'Line'" :href=item.content target="_blank">
            <img src="https://storage.healthathome.in.th/eb597c7f-ab59-4ad2-9bf3-27624ec8a3d0.svg" class="imagebox" alt="video">
          </a>
          <a v-if="item.type === 'audio' && item.content != '' && item.sender.name !== 'Line'" :href=item.content target="_blank">
            <img src="https://storage.healthathome.in.th/2e521bda-6642-4d66-adbd-21fbf8663afd.svg" class="imagebox" alt="audio">
          </a>
        </div>
        <div v-if="item.sender.type === 'admin' && canSplit(item.content)" class="people-hah mt-16 sender-text">{{showSenderName(item.sender.name)}}</div>
        <div v-if="item.sender.type === 'admin' && canSplit(item.content)" class="people-hah">
          <span class="time chat-paragraph-14-lightgray-2">{{getTime(item.timestamp)}}</span>
          <div v-if="item.type === 'text' && item.sender.name === 'Line'" class="chatbox-bot chat-paragraph-16-white" v-html="checkHaveHeader(changeText(item.content), 1)"></div>
        </div>
      </div>
    </div>

    <div class="chat-input" id="chat-input">
      <textarea ref="message" :disabled="disabled" placeholder="พิมพ์ข้อความ.." class="chat-paragraph-16-black" rows="3"
        @keydown.enter.exact.prevent
        @keyup.enter.exact.prevent="sendText"
        @blur="saveMessage()">
      </textarea>
      <button :disabled="disabled" v-on:click.prevent="uploadPicture" style="margin-right: 24px;">
        <img class="upload-img" src="@/assets/icon/upload-img.svg" alt="upload-img" height="20" width="20">
      </button>
      <button :disabled="disabled" v-on:click.prevent="sendText">
        <img class="send" src="@/assets/icon/send.svg" alt="send" height="20" width="20">
      </button>
    </div>

    <el-dialog :visible.sync="showUploadFileDialog" :before-close="clear">
      <div class="header-bold-18 mar-top-20 mar-bottom-24">อัพโหลดรูป
        <span class="header-regular-16"> &nbsp; (ไฟล์มีขนาดไม่เกิน 2 MB)</span>
      </div>
      <el-upload
        class="text-center"
        ref="upload"
        drag
        action=""
        accept=".jpeg, .jpg, .png"
        :limit="1"
        :on-exceed="handleExceed"
        :http-request="addAttachment"
        :auto-upload="false"
        :on-change="handleChange"
        list-type="picture">
        <i class="el-icon-upload">
          <div class="el-upload__text">Drop file here or &nbsp;
            <em>click to upload</em>
          </div>
        </i>
      </el-upload>
      <span class="dialog-footer" slot="footer">
        <el-button class="edit" type="primary" @click="clear()" plain>ยกเลิก</el-button>
        <el-button
          disabled="disabled"
          id="uploadButton"
          type="primary"
          @click="submitUpload()"
          >อัพโหลด
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="showNoteDialog"
      :show-close="false"
      :before-close="() => {
        showNoteDialog = false
        noteForm.status = [...noteDetail.status]
        noteForm.note = noteDetail.note
      }"
    >
      <div
        class="header-bold-18"
        style="margin-top: 12px;"
      >
        แท็ก
      </div>
      <div class="tag-container">
        <label
          v-for="s in rawStatus"
          :key="s.title"
          :for="s.value"
          class="tag"
          :class="{ 'checked': noteForm.status.includes(s.value) }"
          :style="`
            --t-color: ${s.textColor};
            --bg-color: ${s.bgColor};
            --bg-color-hover: ${s.bgColorHover};
          `"
        >
          <input type="checkbox" :id="s.value" :value="s.value" name="tags" v-model="noteForm.status" style="display: none;">
          <img
            :src="s.icon"
            :alt="s.value"
          >
          <span>{{ s.title }}</span>
          <svg
              v-if="noteForm.status.includes(s.value)"
              xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"
          >
            <path d="M5.3335 5.33334L10.6668 10.6667" :stroke="s.textColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10.6668 5.33334L5.3335 10.6667" :stroke="s.textColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </label>
      </div>
      <div
        class="header-bold-18"
        style="margin-top: 24px;"
      >
        โน้ต
      </div>
      <el-input
        v-model.number="noteForm.note"
        style="margin-top: 8px;"
      ></el-input>
      <span class="dialog-footer" slot="footer">
        <el-button
          class="edit"
          type="primary"
          @click="() => {
            showNoteDialog = false
            noteForm.status = [...noteDetail.status]
            noteForm.note = noteDetail.note
          }"
          plain
        >
          ยกเลิก
        </el-button>
        <el-button
          :disabled="false"
          id="uploadButton"
          type="primary"
          @click="submitNote()"
        >
          บันทึก
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ChatMessageModel from '@/model/ChatMessageModel'
import { GenericAPIHandler } from '../shared/GenericAPIHandler'
import { UploadImageHandler } from '@/components/shared/UploadImageHandler'
import { Storage } from '@/model/ModelUtil'
import moment from 'moment'

export default {
  name: 'ChatDisplay',
  mixins: [GenericAPIHandler, UploadImageHandler],
  mounted () {
    this.setInfo({ lineId: this.$route.query.id })
    this.showNoteSection = false
    this.getChatHistory(false)
    this.offset = 0
    this.$nextTick(() => {
      setTimeout(() => {
        document.getElementById('chat-container').style.height = `calc(100vh - ${document.getElementById('contact-header').clientHeight || 0}px - ${document.getElementById('chat-input').clientHeight || 0}px - 94px)`
      }, 300)
    })
  },
  beforeDestroy () {
    clearTimeout(this.interval)
    clearTimeout(this.intervalLoadHistory)
    if (this.chatEvent) {
      this.chatEvent.close()
      this.chatEvent = null
    }
  },
  props: {
    infoProps: Object,
    show: Boolean,
    filter: Object,
  },
  data () {
    return {
      info: {},
      chat: [],
      list: [],
      disabled: false,
      interval: '',
      showUploadFileDialog: false,
      showNoteDialog: false,
      messageObj: Storage.list.fromJson('msgObj'),
      chatEvent: null,
      intervalLoadHistory: null,
      timeToLoad: 0,
      loading: true,
      offset: 0,
      tempHeight: 0,
      showNoteSection: true,
      noteForm: {
        status: [],
        note: '',
      },
      noteDetail: {
        status: [],
        note: '',
      },
      rawStatus: [
        {
          title: 'ส่งใบเสร็จ',
          value: 'receipt',
          icon: 'https://storage.healthathome.in.th/31619663-26e4-495e-986b-b29941946576.svg',
          textColor: '#60B8B2',
          bgColor: '#DBFFFC',
          bgColorHover: '#C3F4F0'
        },
        {
          title: 'ส่งใบเสร็จและตัวจริง',
          value: 'receiptAndOriginal',
          icon: 'https://storage.healthathome.in.th/de7a577b-5aff-4b0e-86ec-04916102e0ab.svg',
          textColor: '#5489FF',
          bgColor: '#EDF3FF',
          bgColorHover: '#D4E1FF'
        },
        {
          title: 'สอบถามต่อสัญญา',
          value: 'renewContract',
          icon: 'https://storage.healthathome.in.th/be47dc3c-72f7-41fd-a3b5-7082b4d9542a.svg',
          textColor: '#FB8360',
          bgColor: '#FFF0EC',
          bgColorHover: '#FFD7CB'
        },
        {
          title: 'Unsub ทุกเดือน',
          value: 'unsub',
          icon: 'https://storage.healthathome.in.th/b1ed0bd6-42bf-40e5-9253-c6a143689dbb.svg',
          textColor: '#FF577F',
          bgColor: '#FFEEF2',
          bgColorHover: '#FFCBD7'
        },
        {
          title: 'VIP',
          value: 'vip',
          icon: 'https://storage.healthathome.in.th/16898b27-e143-49ee-b298-8b2700f4e931.svg',
          textColor: '#FFB424',
          bgColor: '#FFF4D6',
          bgColorHover: '#FFE8A9'
        }
      ]
    }
  },
  watch: {
    infoProps: function (newVal, oldVal) {
      this.setInfo(newVal)
      this.loading = true
      this.$emit('loadingHandler', this.loading)
      this.showNoteSection = false
      this.getChatHistory(false)
    },
  },
  computed: {
    id: function () {
      if (this.info.patientId === 0) return 'N/A'
      else return `P${this.info.patientId}`
    },
  },
  methods: {
    getChat () {
      if (this.chatEvent) {
        this.chatEvent.close()
      }
      if (this.info.lineId) {
        // flag to prevent flashing screen when connection reset

        this.chatEvent = this.$api.Chat.getSse(this.info.lineId)

        let buffer = []
        let flushBuffer = false
        this.chatEvent.addEventListener('open', () => {
          buffer = []
        })
        this.chatEvent.addEventListener('message', (ev) => {
          try {
            const data = JSON.parse(ev.data)
            if (data.type === 'noteUpdate') {
              this.noteDetail = JSON.parse(JSON.stringify({
                status: data.status,
                note: data.note,
              }))
              this.noteForm = JSON.parse(JSON.stringify({
                status: data.status,
                note: data.note,
              }))

              return
            }
            buffer.push(ChatMessageModel.fromJSON(data))
            if (!flushBuffer) {
              flushBuffer = true
              setTimeout(() => {
                this.chat.push(...buffer)
                buffer = []
                flushBuffer = false
              }, 1000)
            }
          } catch (e) {
            this.showErrorDialog(e)
          }
        })
      }
    },
    loadHistoryInterval () {
      this.loadHistoryHandler()
      if (this.timeToLoad <= 3 && this.chat.length > 0) {
        this.intervalLoadHistory = setTimeout(() => {
          this.loadHistoryInterval()
        }, 1000)
      } else {
        clearTimeout(this.intervalLoadHistory)
      }
    },
    loadHistoryHandler () {
      this.timeToLoad++
      if (this.timeToLoad === 3 && this.chat.length > 0) {
        this.getChatHistory(true)
      }
    },
    async getChatHistory (scroll) {
      setTimeout(async () => {
        this.tempHeight = this.$refs.chat.scrollHeight
        const lineId = this.info.lineId
        if (lineId) {
          try {
            const res = await this.$api.Chat.get(lineId, this.offset)
            this.noteDetail = JSON.parse(JSON.stringify(res.note))
            this.noteForm = JSON.parse(JSON.stringify(res.note))
            this.info = { lineId: this.$route.query.id, ...res.info }
            this.offset += 50
            this.showNoteSection = true
            setTimeout(() => {
              if (res.messages.length > 0) {
                this.chat = [...res.messages, ...this.chat]
              }
              this.loading = false
              this.$emit('loadingHandler', this.loading)

              setTimeout(() => {
                if (scroll) {
                  this.$refs.chat.scrollTo(0, this.$refs.chat.scrollHeight - this.tempHeight)
                } else {
                  this.gotoBottom()
                  setTimeout(() => {
                    let scroll = this.$refs.chat.scrollTop
                    do {
                      scroll = this.$refs.chat.scrollTop
                      this.gotoBottom()
                    } while (scroll !== this.$refs.chat.scrollTop)
                  }, 300)
                }
                document.getElementById('chat-container').style.height = `calc(100vh - ${document.getElementById('contact-header').clientHeight || 0}px - ${document.getElementById('chat-input').clientHeight || 0}px - 94px)`
              }, 200)
            }, 200)
          } catch (error) {
            this.showErrorDialog(error)
            this.loading = false
            this.$emit('loadingHandler', this.loading)
          }
        }
      }, 500)
    },
    scrollHandler () {
      if (this.$refs.chat.scrollTop < 10 && !this.loading && this.chat.length > 0 && this.timeToLoad === 0) {
        this.loading = true
        this.loadHistoryInterval()
      } else if (this.$refs.chat.scrollTop >= 10) {
        this.loading = false
        this.timeToLoad = 0
        clearTimeout(this.intervalLoadHistory)
      }
      this.$emit('loadingHandler', this.loading)
    },
    setInfo (value) {
      this.info = value
      this.$nextTick(() => {
        this.$refs.message.value = this.messageObj[this.info.lineId] ? this.messageObj[this.info.lineId] : ''
      })
      this.offset = 0
      this.chat = []
      this.getChat()
      // this.getChatHistory(false)
    },
    async sendText (event) {
      event.preventDefault()
      await this.sendMessage('', 'text')
    },
    async sendImage (imgURL) {
      await this.sendMessage(imgURL, 'image')
    },
    async sendMessage (imgURL, type) {
      let content
      if (type === 'image') content = imgURL
      else content = this.$refs.message.value
      if (content.trim() !== '') {
        try {
          this.disabled = true
          await this.$api.Chat.send(this.info.lineId, content, type)
          this.$refs.message.value = ''
          this.saveMessage()
          this.disabled = false
        } catch (error) {
          this.showErrorDialog(error)
          this.disabled = false
        }
      }
    },
    async uploadPicture (event) {
      this.showUploadFileDialog = true
    },
    handleChange (file, fileList) {
      if (fileList.length > 0) {
        this.handleUploadButton(false)
      }
    },
    clear () {
      this.$refs.upload.clearFiles()
      this.handleUploadButton(true)
      this.showUploadFileDialog = false
    },
    handleUploadButton (val) {
      const buttonUpload = document.getElementById('uploadButton')
      if (val === true) {
        buttonUpload.disabled = true
        buttonUpload.classList.add('is-disabled')
      } else {
        buttonUpload.disabled = false
        buttonUpload.classList.remove('is-disabled')
      }
    },
    async addAttachment (upload) {
      if (!this.isImageAllowUpload(upload.file)) return
      try {
        let raw = await this.$api.Chat.upload(upload.file)
        let img = raw.downloadUrl
        this.sendImage(img)
        this.$message.success('เพิ่มรูปภาพแล้ว')
        this.clear()
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
   async  submitNote () {
     try {
       await this.$api.Chat.setNote(this.info.lineId, this.noteForm.status, this.noteForm.note)
       this.showNoteDialog = false
       this.noteForm.status = []
       this.noteForm.note = ''
     } catch (error) {
       this.showErrorDialog(error)
       this.loading = false
       this.$emit('loadingHandler', this.loading)
     }
    },
    submitUpload () {
      this.$refs.upload.submit()
      this.handleUploadButton(true)
    },
    checkHaveHeader (data, index) {
      // eslint-disable-next-line
		  let regexHeader = /(\[).*(\])/g
      let mess = data.split('&lt;split&gt;')
      if (mess[index].match(regexHeader)) return `${mess[index]}`
      return `<div style="color: #5489FF !important; max-width: 429px;">${mess[index]}</div>`
    },
    canSplit (data) {
      return data.split('<split>').length > 1
    },
    changeText (data) {
      const regexHeader = /(\[).*(\])/g
      // eslint-disable-next-line
      const regexLink = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.,;~#?&//=]*)/g
      return data.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(regexHeader, function (text) {
        return `<span style="color: #5489FF; font-weight: 700;">${text}</span>`
      }).replace(regexLink, function (url) {
        return `<a target="_blank" href="${url}"><u>${url}</u></a>`
      }).replace(/\n/g, '<br>').replace(/----------/g, '<hr style="margin: 0; border: 0.5px solid #D4E1FF;">')
    },
    goToCustomerPage () {
      const routerData = this.$router.resolve({ name: 'PatientDetail', params: { id: this.info.patientId }, query: { tab: 'patientinfoTab' } })
      window.open(routerData.href, '_blank')
    },
    getTime (date) {
      return moment(date).format('HH:mm')
    },
    getDate (date) {
      let a = moment(date).format('YYYY-MM-DD')
      let b = moment().format('YYYY-MM-DD')
      if (moment(b) - moment(a) === 0) {
        return 'วันนี้'
      } else if (moment(b) - moment(a) === 86400000) {
        return 'เมื่อวาน'
      } else {
        const day = ['(อา.)', '(จ.)', '(อ.)', '(พ.)', '(พฤ.)', '(ศ.)', '(ส.)']
        const month = ['', 'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.']
        const d = moment(date).format('D')
        const m = month[parseInt(moment(date).format('M'))]
        const y = moment(date).format('YYYY')
        const dof = day[parseInt(moment(date).format('d'))]
        return `${d} ${m} ${y} ${dof}`
      }
    },
    showDate (index) {
      if (index !== 0) {
        const current = moment(this.chat[index].timestamp).format('YYYY-MM-DD')
        const next = moment(this.chat[index - 1].timestamp).format('YYYY-MM-DD')
        if (moment(current) - moment(next) !== 0) return true
      }
      return false
    },
    showSenderName (name) {
      if (name === 'Line') return 'Bot'
      else return name
    },
    saveMessage () {
      if (this.$refs.message.value.trim().length > 0) {
        this.messageObj[this.info.lineId] = this.$refs.message.value
      } else {
        delete this.messageObj[this.info.lineId]
      }
      localStorage.setItem('msgObj', JSON.stringify(this.messageObj))
    },
    getProfile (uid) {
      return this.$api.Chat.profile(uid)
    },
    gotoBottom () {
      this.$refs.chat.scrollTo(0, this.$refs.chat.scrollHeight)
    },
  },
}
</script>

<style lang="scss">
  .people-customer {
    .chatbox {
      a {
        color: #606266;
      }
    }
  }

  .people-hah {
    .chatbox {
      a {
        color: #fff;
      }
    }
  }

  .el-dialog__body {
    padding: 40px 56px !important;
  }

  .el-dialog__footer {
    padding: 0 24px 24px 40px !important;
  }

  .el-upload-list {
    margin-top: 40px !important;
  }
</style>
<style lang="scss" scoped>
  .note-button {
    margin-top: 8px;
    font-size: 12px;
    font-weight: 500;
    font-family: Sukhumvit-Medium;
    color: #5489FF;
    transition: .2s;
    cursor: pointer;

    &:hover {
      opacity: 0.75;
    }
  }

  .note {
    font-size: 12px;
    font-weight: 500;
    font-family: Sukhumvit-Medium;
    color: #434B61;
  }

  .header-bold-18 {
    font-size: 18px;
    font-weight: bold;
    font-family: Sukhumvit-Bold;
  }

  .mar-top-20 {
    margin-top: 20px;
  }

  .mar-bottom-24 {
    margin-bottom: 24px;
  }

  .mar-bottom-40 {
    margin-bottom: 40px;
  }

  .header-regular-16 {
    font-size: 16px;
    font-weight: normal;
    font-family: Sukhumvit;
  }

  .text-center {
    text-align: center;
  }

  .el-upload__text {
    font-family: 'Sukhumvit-Medium';
    font-weight: normal;
  }

  .edit {
    background-color: #fff;
    border: 2px solid #409EFF;
  }

  .container {
    padding-top: 34px;
    width: calc(100vw - 386px);
    height: 100%;
    margin: 0;
  }

  .contact-header {
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 24px;
    display: flex;
    flex-direction: row;
    border-bottom: solid 1px #dcdfe6;
    height: auto;
  }

  .contact-profile-image {
    width: 60px;
    height: 60px;
    background: #ffffff;
    border-radius: 30px;
  }

  .contact-profile {
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  span.chat-header-24-black {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .customer-button {
    background: none;
    border: 0;
    outline: 0;
  }

  .active {
    &:hover {
      cursor: pointer;
      opacity: 0.7;
    }
  }

  .disabled {
    opacity: 0.5;

    &:hover {
      cursor: not-allowed;
    }
  }

  img.icon {
    width: 25px;
    height: 29px;
    margin-left: 6px;
  }

  .chat-container {
    width: 100%;
    overflow-y: scroll;
    padding: 30px;
    display: flex;
    flex-direction: column;
    padding-bottom: 40px;
  }

  .chat-input {
    font-family: 'Thonburi';
    line-height: 19px;
    position: fixed;
    bottom: 0;
    min-height: 102px;
    border-top: solid 1px #dcdfe6;
    width: 100%;

    textarea {
      width: calc(100% - 386px);
      height: calc(100% - 194px);
      border: 0;
      outline: 0;
      padding: 13px 100px 25px 31px;
      resize: none;

      &::placeholder {
        color: #c0c4cc;
      }

      &:disabled {
        background: #FFFFFF;
      }
    }

    .send {
      z-index: 1001;
      position: fixed;
      bottom: 22px;
      right: 40px;
    }

    .upload-img {
      z-index: 1001;
      position: fixed;
      bottom: 22px;
      right: 84px;
    }
  }

  .mt-16 {
    margin-top: 16px;
  }

  .mt-20 {
    margin-top: 20px;
  }

  .mb-12 {
    margin-bottom: 12px;
  }

  .people-hah {
    font-family: 'Thonburi';
    line-height: 22px;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    align-self: flex-end;
    justify-content: flex-end;
    padding-left: 40px;

    .time {
      margin-right: 8px;
    }

    .chatbox {
      padding: 16px 36px 16px 36px;
      background: #5489FF;
      border-radius: 20px 0 20px 20px;
    }

    .chatbox-bot {
      padding: 25px;
      background: #E7EEFF;
      color: #7FA7FF;
      border-radius: 20px 0 20px 20px;
    }

    .imagebox {
      max-width: 300px;
      border-radius: 12px 0 6px 12px;
    }
  }

  .sender-text {
    font-family: 'Sukhumvit-Light';
    color: #A2A7B2;
  }

  .people-customer {
    font-family: 'Thonburi';
    line-height: 22px;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    align-self: flex-start;

    .image {
      min-height: 28px;
      min-width: 28px;
      border-radius: 14px;
      margin-right: 12px;
      background: #ffffff;
      align-self: flex-start;
    }
  ่
    .time {
      margin-left: 8px;
    }

    .chatbox {
      padding: 7px 20px 7px 16px;
      background: #FFFFFF;
      border: 1px solid #D5D6DB;
      border-radius: 0 40px 40px 25px;
    }

    .imagebox {
      max-width: 240px;
      border-radius: 0 12px 12px 6px;
    }

    .stickerbox {
      max-width: 140px;
      border-radius: 0 12px 12px 6px;
    }
  }

  .date {
    display: flex;
    align-self: center;
    justify-content: center;
  }

  .loading-container {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .tag-container {
    margin-top: 8px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
    user-select: none;

    .tag {
      display: flex;
      padding: 2px 6px 2px 6px;
      align-items: center;
      gap: 4px;
      border-radius: 8px;
      cursor: pointer;
      transition-duration: .3s;
      background: var(--bg-color);
      border: 1px solid var(--bg-color);

      &.checked {
        border: 1px solid var(--t-color);
      }

      span {
        color: var(--t-color);
        font-family: 'Sukhumvit-SemiBold';
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 175%;
      }

      &:hover {
        background: var(--bg-color-hover);
      }
    }
  }
</style>
